import axios from 'axios'

const url = window.location.href
const urlParams = new URLSearchParams(window.location.search)

export const tokens = {
  authId: urlParams.get('AUTH_ID') || '',
  refreshId: urlParams.get('REFRESH_ID') || ''
}

if (tokens.authId) {
  localStorage.setItem('tokens', JSON.stringify(tokens))
}

const placementOptionsJson = urlParams.get('PLACEMENT_OPTIONS')
const placementOptions = JSON.parse(placementOptionsJson)
if (placementOptions && placementOptions['open-paid-service']) {
  window.location = `/service-page/${placementOptions['open-paid-service']}`
}

let baseUrl = 'https://paid-services.crm.vdkanal.ru/api/'
if (url.includes('dev')) {
  baseUrl = 'https://dev-paid-services.crm.vdkanal.ru/api/'
} else if (url.includes('localhost')) {
  // baseUrl = 'http://localhost:3901/api/'
  baseUrl = 'https://dev-paid-services.crm.vdkanal.ru/api/'
}

const sessionTokens = JSON.parse(localStorage.getItem('tokens') || '{}')
const api = axios.create({
  baseURL: baseUrl,
  headers: {
    'X-Access-Token': sessionTokens.authId,
    'X-Refresh-Token': sessionTokens.refreshId,
    'X-App-Type': 'paidServices'
  }
})

export default api
